export default __webpack_public_path__ + "static/media/devchallenges.87158787.svg";